function TrackingPage() {
  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <h1 className="text-2xl font-bold mb-4">Tracking Page</h1>
        <p className="text-gray-600">Package tracking coming soon...</p>
      </div>
    </div>
  );
}

export default TrackingPage;
